import * as React from 'react';
import { useSelector } from 'react-redux';

import { ETAZHI_BLACK_FRIDAY_CAROUSEL_OPTIONS } from './constants';
import { Carousel as EtazhiBlackFridayPromoOffersCarousel } from '../../../packages/Carousel/Carousel';
import { EtazhiBlackFridayCard } from 'shared/components/EtazhiBlackFridayCard';
import { EtazhiBlackFridayPromoOfferCard } from 'shared/components/EtazhiBlackFridayPromoOfferCard';
import { EtazhiBlackFridayPromoOffersLayout } from 'shared/components/EtazhiBlackFridayPromoOffersLayout';
import {
  selectEtazhiBlackFridayPromoOffers,
  selectEtazhiBlackFridayPromoOffersData,
  selectEtazhiBlackFridaySerpLink,
} from 'shared/selectors/etazhiBlackFriday';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function EtazhiBlackFridayPromoOffers() {
  const promoOffers = useSelector(selectEtazhiBlackFridayPromoOffers);
  const promoOffersData = useSelector(selectEtazhiBlackFridayPromoOffersData);
  const serpLink = useSelector(selectEtazhiBlackFridaySerpLink);

  const slides = React.useMemo(
    () =>
      promoOffers?.length
        ? promoOffers.map(offer => (
            <EtazhiBlackFridayPromoOfferCard key={offer.id} offer={offer} onOfferClick={() => {}} />
          ))
        : [],
    [promoOffers],
  );

  const carousel = React.useMemo(
    () => (
      <EtazhiBlackFridayPromoOffersLayout
        offersViewed={promoOffers ? promoOffers?.length < ETAZHI_BLACK_FRIDAY_CAROUSEL_OPTIONS.slidesPerView : true}
        card={
          <EtazhiBlackFridayCard
            onLogoClick={() => {}}
            onButtonClick={() => {}}
            promoOffersData={promoOffersData}
            serpLink={serpLink}
          />
        }
        carousel={
          <EtazhiBlackFridayPromoOffersCarousel {...ETAZHI_BLACK_FRIDAY_CAROUSEL_OPTIONS}>
            {slides}
          </EtazhiBlackFridayPromoOffersCarousel>
        }
      />
    ),
    [promoOffers, slides, promoOffersData, serpLink],
  );

  if (!promoOffers) {
    return null;
  }

  return carousel;
}
